import { CONTROLS, FRAMEWORKS } from "@aigov/domain";
import { api, type LibraryDto } from "../api";
import { errMsg } from "../ui";

export function CrosswalkView({ library, platformAdmin, onChange, toast }: {
  library: LibraryDto; platformAdmin: boolean; onChange: () => Promise<void>; toast: (m: string) => void;
}) {
  const verified = new Map(library.verifications.map((v) => [`${v.controlId}:${v.framework}`, v]));

  const toggle = async (controlId: string, fw: string) => {
    const on = verified.has(`${controlId}:${fw}`);
    try {
      await api(on ? "DELETE" : "PUT", `/library/verifications/${controlId}/${fw}`, on ? undefined : { note: "" });
      await onChange();
      toast(on ? "Verification cleared" : "Marked verified");
    } catch (e) { toast(errMsg(e)); }
  };

  return (
    <section className="panel">
      <div className="row spread" style={{ marginBottom: 8 }}><h2>Control library crosswalk</h2>
        <span className="muted small">{CONTROLS.length} controls × {FRAMEWORKS.length} frameworks · v{library.version}</span></div>
      <p className="muted small" style={{ margin: "0 0 10px", maxWidth: "80ch" }}>
        References point to clauses, articles and practices. They are paraphrased pointers, not standard text.
        {platformAdmin ? " Select a reference once you have checked it against the official or licensed text. Verification applies across every workspace." : " Your practice administrator verifies references against the official text."}
      </p>
      <div className="legend" style={{ marginBottom: 10 }}>
        <span><span className="vdot v-S" />Checked against a published source</span>
        <span><span className="vdot v-M" />From working knowledge, verify</span>
        <span><span className="vdot v-V" />Verified against the official text</span>
      </div>
      <div className="scroll"><table className="xw">
        <thead><tr><th>Control</th>{FRAMEWORKS.map((f) => <th key={f.key}>{f.name}</th>)}</tr></thead>
        <tbody>{CONTROLS.map((c) => (
          <tr key={c.id}><td><span className="mono">{c.id}</span> <strong>{c.title}</strong></td>
            {FRAMEWORKS.map((fw) => {
              const ref = c.refs[fw.key];
              if (!ref) return <td key={fw.key} className="ref muted">·</td>;
              const v = verified.get(`${c.id}:${fw.key}`);
              return <td key={fw.key} className="ref">
                <button className="ref" disabled={!platformAdmin} onClick={() => toggle(c.id, fw.key)}
                  title={v ? `Verified ${new Date(v.verifiedAt).toLocaleDateString("en-GB")}` : platformAdmin ? "Select to mark verified" : undefined}>
                  <span className={`vdot v-${v ? "V" : fw.confidence}`} />{ref}</button></td>;
            })}
          </tr>))}
        </tbody>
      </table></div>
    </section>
  );
}
